import { useEffect, useRef, useState } from "react";
import { getWidgetOrigin } from "../utils/getWidgetUrl";
import { collectReserveWithGoogleConversion } from "../utils/collectReserveWithGoogleConversion";

export const useMountWidget = (
  iFrame: any,
  clientKey?: string,
  schedulerSrc?: string,
  validOrigins?: Array<string>
): boolean => {
  const [isCardVisible, setIsCardVisible] = useState<boolean>(true);
  const conversionSentRef = useRef<boolean>(false);

  useEffect(() => {
    const handleMessageFromChild = (event: any) => {
      if (validOrigins && validOrigins.length > 0) {
        if (!validOrigins.includes(event.origin)) {
          return;
        }
      }

      switch (event.data.type) {
        case "se-app-ready":
          if (iFrame.current) {
            setIsCardVisible(false);
            iFrame.current.contentWindow?.postMessage(
              {
                type: "se-show-modal",
              },
              clientKey ? getWidgetOrigin(clientKey) : schedulerSrc
            );
          }

          break;
        case "se-event":
          if (event.data.eventName === "BookingBooked") {
            if (!conversionSentRef.current) {
              conversionSentRef.current = true;
              collectReserveWithGoogleConversion();
            }
          }

          break;
        default:
          // Do nothing
          break;
      }
    };

    window.addEventListener("message", handleMessageFromChild);

    return () => {
      window.removeEventListener("message", handleMessageFromChild);
    };
  }, [iFrame, clientKey, schedulerSrc, validOrigins]);

  return isCardVisible;
};
